import {ReactNode} from "react";
import './Divider.scss'

interface DividerParams {
    children: ReactNode|ReactNode[]|string;
}

export default function Divider({ children }: DividerParams) {
    return (
        <div className="position-relative">
            <hr className="border border-warning border-3 opacity-75" />
            <span className="position-absolute bg-white px-3 labelHr">
                <small>{children}</small>
            </span>
        </div>
    );
}